import type { RipplingMigrationStatusFields } from '@/data/migration/model';
import Monolith from '@/shared/api/monolith';
import { parseAPIError } from '@/shared/redux/helpers/parseApiError';
import { createWiwAsyncThunk, type WiwDispatch, type WiwGetState, type WiwState } from '@/store';

import * as Sentry from '@sentry/react';
import moment from 'moment-timezone';
import { WretchError } from 'wretch/resolver';

export const fetchMigrationStatus = createWiwAsyncThunk<RipplingMigrationStatusFields | null>(
  'ripplingMigration/fetch',
  async (_, { rejectWithValue }) => {
    try {
      return (await Monolith.get('/migration/status')) as RipplingMigrationStatusFields;
    } catch (error) {
      // Treat 404 as successful responses with null data
      if (error instanceof WretchError && error.status === 404) {
        return null;
      }

      Sentry.captureException(error, {
        tags: {
          error_type: 'fetch_migration_status',
        },
      });

      return rejectWithValue(parseAPIError(error));
    }
  },
);

function shouldFetchMigrationStatus(state: WiwState) {
  if (state.data.migration.get('loading')) {
    return false;
  }

  const receivedAt = state.data.migration.get('receivedAt');
  if (!receivedAt) {
    return true;
  }

  return moment(receivedAt).isBefore(moment().subtract(60, 'minutes'));
}

export function fetchMigrationStatusIfNeeded() {
  return (dispatch: WiwDispatch, getState: WiwGetState) => {
    if (shouldFetchMigrationStatus(getState())) {
      return dispatch(fetchMigrationStatus());
    }
  };
}
